import { http, HttpResponse } from 'msw'

interface MockDeactivateCostumizationPathParams {
  alphaId: string
  slipCustomizationAlphaId: string
}

export const mockDeactivateSlipCostumization =
  http.put<MockDeactivateCostumizationPathParams>(
    '/my-business/api/agency/v1/*/:alphaId/slip-customization/:slipCustomizationAlphaId/deactivate',
    () => {
      return HttpResponse.json(null, { status: 200 })
    },
  )
